import { CommentsConstants } from './comments.constants'
import { ICommentsState } from './comments.types'

export const initialCommentsState: ICommentsState = {
  commentPageTitle: '',
  commentText: '',
  commentMaxLength: 500,
  onChangeAction: [],
  saveAction: [],
  previousPagePath: '',
  hideComments: false,
}

export function commentsReducer(state: ICommentsState = initialCommentsState, action: any): ICommentsState {
  switch (action.type) {
    case CommentsConstants.SET_COMMENT_TEXT:
      return { ...state, commentText: action.commentText }
    case CommentsConstants.SET_COMMENT_PAGE_TITLE:
      return { ...state, commentPageTitle: action.commentPageTitle }
    case CommentsConstants.SET_COMMENT_MAX_LENGTH:
      return { ...state, commentMaxLength: action.commentMaxLength }
    case CommentsConstants.SET_PREVIOUS_PAGE_PATH:
      return { ...state, previousPagePath: action.previousPagePath }
    case CommentsConstants.SET_ON_CHANGE_ACTION:
      return { ...state, onChangeAction: action.onChangeAction }
    case CommentsConstants.SET_SAVE_ACTION:
      return { ...state, saveAction: action.saveAction }
    case CommentsConstants.HIDE_COMMENTS:
      return { ...state, hideComments: action.hideComments }
    case CommentsConstants.RESET_COMMENTS_STATE:
      return { ...initialCommentsState }
    default:
      return state
  }
}
